<template>
  <DialogCard>
    <template #title>
      Science &amp; Patents
    </template>
    <template #text>
      <p>
        neuralike is built on rigorous and replicable science. We are committed to the highest
        scientific standards and being a trusted source of healthcare information. We make decisions
        based on scientific evidence and employ data to better understand wellness and disease. We
        bring science to our customers to help them understand medical images in meaningful ways. By
        following the scientific method, we aim to break new ground leading to innovative services.
      </p>
      <p>
        Important features of neuralike's services are patent-protected. The following list is
        offered to fulfil virtual patent marking provisions of various jurisdictions. Additional
        patents may be pending in the United States or elsewhere.
      </p>
      <p>
        Brain Health Comparison System, U.S. 16/241,967
      </p>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'NeuralikeSciencePatentsDialog',
  components: {
    DialogCard,
  },
};
</script>
